import { API_ENDPOINTS } from '../config/api';

// What each person may do (Organization & approval workflows). The server checks every permission; the UI only
// hides what a person can't use. Designation is display-only.
export const PERMISSIONS = [
  { key: 'create_jobs', label: 'Create jobs', hint: 'Hiring manager: Add New Job + Jessica call' },
  { key: 'approve_jobs', label: 'Approve jobs', hint: 'Approves jobs in an approval step' },
  { key: 'approve_pay', label: 'Approve pay / budget', hint: 'HR or Finance compensation step' },
  { key: 'receive_assign', label: 'Receive & assign jobs', hint: 'Head of TA, recruitment manager, lead' },
  { key: 'recruit', label: 'Recruit', hint: 'Works assigned jobs, schedules Alex screens' },
  { key: 'interview', label: 'Interview', hint: 'Can be picked as an interviewer in job rounds' },
];

const RECRUITING = ['Recruitment Manager', 'Recruitment Lead', 'Senior Recruiter', 'Recruiter', 'Sourcing Recruiter'];

// A new person's starting permissions from the designation picked (the same mapping as the server's default).
export function defaultPermissions(designation) {
  if (designation === 'Hiring Manager') return ['create_jobs', 'interview'];
  if (designation === 'Interviewer') return ['interview'];
  if (RECRUITING.includes(designation)) return ['recruit'];
  return [];
}

export function hasPermission(user, key) {
  return !!(user && Array.isArray(user.permissions) && user.permissions.includes(key));
}

// The hiring-manager experience (My Requisitions, HM meetings): Create jobs without Recruit; never a company admin.
export function isHmView(user) {
  return !!user && user.role !== 'company_super_admin' && hasPermission(user, 'create_jobs') && !hasPermission(user, 'recruit');
}

// Refresh the stored user's permissions from the server (a session from before this release has none, and an
// admin may have changed them). Resolves to the updated user, or null when nothing changed.
export async function refreshStoredPermissions() {
  let stored;
  try { stored = JSON.parse(localStorage.getItem('user') || 'null'); } catch { stored = null; }
  const token = localStorage.getItem('token');
  if (!stored || !token) return null;
  try {
    const r = await fetch(API_ENDPOINTS.USERS_ME, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) return null;
    const me = await r.json();
    const fresh = (me && me.user && me.user.permissions) || [];
    if (JSON.stringify(fresh) === JSON.stringify(stored.permissions || null)) return null;
    const next = { ...stored, permissions: fresh };
    localStorage.setItem('user', JSON.stringify(next));
    return next;
  } catch {
    return null;
  }
}
